import React from "react";

/**
 * Statut de paiement d'une commande.
 *
 * `orders.payment_status` est un entier en base (0 à 7) que l'API sérialise en
 * chaîne. Le mapping vit dans le modèle Rails et n'est pas accessible d'ici :
 * plutôt que de le deviner, on affiche la valeur reçue, mise en forme.
 *
 * Le vocabulaire ci-dessous est celui relevé dans `order_audit_logs.changeset`
 * en production : `to_invoice → invoiced` (21 836 transitions sur 6 mois),
 * `unpaid → payment_pending → paid`, et les échecs. Toute valeur hors de cette
 * liste reste neutre et lisible : un statut inconnu doit s'afficher tel quel,
 * pas disparaître ni prendre une couleur qui lui prêterait un sens.
 *
 * `to_invoice` est la commande groupée dans une facture en cours ; `invoiced`
 * la facture émise. Les deux sont des fins normales pour un point de collecte,
 * d'où le vert — rien n'est en souffrance.
 */
const TONES = {
  paid: { bg: "#DFF2F2", fg: "#1F7A7F" },
  invoiced: { bg: "#DFF2F2", fg: "#1F7A7F" },
  to_invoice: { bg: "#EAF3FF", fg: "#1D4E89" },
  completed: { bg: "#DFF2F2", fg: "#1F7A7F" },
  succeeded: { bg: "#DFF2F2", fg: "#1F7A7F" },
  pending: { bg: "#FDF0D5", fg: "#8A6100" },
  payment_pending: { bg: "#FDF0D5", fg: "#8A6100" },
  processing: { bg: "#FDF0D5", fg: "#8A6100" },
  unpaid: { bg: "#FEE2E2", fg: "#B91C1C" },
  failed: { bg: "#FEE2E2", fg: "#B91C1C" },
  payment_failed: { bg: "#FEE2E2", fg: "#B91C1C" },
  payment_timeout: { bg: "#FEE2E2", fg: "#B91C1C" },
  canceled: { bg: "#FEE2E2", fg: "#B91C1C" },
  cancelled: { bg: "#FEE2E2", fg: "#B91C1C" },
  refunded: { bg: "#EDEEF7", fg: "#5A5F80" },
};

const NEUTRAL = { bg: "#EDEEF7", fg: "#5A5F80" };

/** « pay_upon_delivery » → « Pay upon delivery ». */
export const humanizePaymentStatus = (status) => {
  if (!status) return null;
  const words = String(status).replace(/_/g, " ").trim();
  return words.charAt(0).toUpperCase() + words.slice(1);
};

const PaymentPill = ({ status, t }) => {
  const label = humanizePaymentStatus(status);
  if (!label) return <span style={{ color: "var(--mgr-ink-4)" }}>—</span>;

  const tone = TONES[String(status).toLowerCase()] || NEUTRAL;

  return (
    <span className="mgr-pill" style={{ background: tone.bg, color: tone.fg }}>
      {t ? t(label) : label}
    </span>
  );
};

export default PaymentPill;
